import { fixed } from './number.utils';

const minDate = new Date(0);

/** Nombre de décimales des champs monétaires de la base Bloomers (Airtable `Currency`). */
const AIRTABLE_CURRENCY_PRECISION = 7;

export const ensureDateNotUndefined = (date: string | Date | undefined): Date => {
  if (!date) {
    return minDate;
  }
  return new Date(date);
};

export const sortDescendingAirtablePricingByStartDate = <T extends { startDate?: string | Date }>(
  pricings: T[],
): T[] => {
  return [...pricings].sort(
    (a, b) => ensureDateNotUndefined(b.startDate).getTime() - ensureDateNotUndefined(a.startDate).getTime(),
  );
};

export const getFirstValidPrice = <T extends { startDate?: string | Date }>(
  prices: T[],
  currentDate: Date,
): T | undefined => {
  return sortDescendingAirtablePricingByStartDate<T>(prices).find(
    (price) => ensureDateNotUndefined(price.startDate) <= currentDate,
  );
};

/**
 * Précision d'un montant monétaire persisté : 7 décimales, comme les champs `Currency` de la
 * table Airtable `activity` qui les stockent (et comme les formules monétaires historiques de
 * cette table). Écrêter plus tôt ferait arrondir la valeur une seconde fois par Airtable.
 *
 * L'arrondi sert ici à absorber le bruit des flottants (`0.1 * 3`), pas à ramener au centime.
 */
export const ensurePricePrecision = (price: number): number => {
  return fixed(price, AIRTABLE_CURRENCY_PRECISION);
};
